/**
 * Placeholder for kanban board to manage reservation status
 */
export default function ReservationsKanbanPage() {
    return <div>Reservations kanban</div>;
}
